import { render, staticRenderFns } from "./DormEditForm.vue?vue&type=template&id=213d0ff0&"
import script from "./DormEditForm.vue?vue&type=script&lang=js&"
export * from "./DormEditForm.vue?vue&type=script&lang=js&"
import style0 from "./DormEditForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports